import foot from '../components/foot'
import MescrollVue from 'mescroll.js/mescroll.vue'
import area from '../components/area.vue'
import goodsItem from '../components/goodsItem'
import sortBar from '../components/sortBar'
import navBar from '../components/navBar'
import navSearchBar from '../components/navSearchBar'
import banner from '../components/banner'
import orderItem from '../components/orderItem'

function plugin (Vue) {
  if (plugin.installed) {
    return
  }
  Vue.component('footBar', foot)
  Vue.component('MescrollVue', MescrollVue)
  Vue.component('cityArea', area)
  Vue.component('goodsItem', goodsItem)
  Vue.component('sortBar', sortBar)
  Vue.component('navBar', navBar)
  Vue.component('navSearchBar', navSearchBar)
  Vue.component('banner', banner)
  Vue.component('orderItem', orderItem)
}
export default plugin



// WEBPACK FOOTER //
// ./src/util/components.js